// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========

import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';

import { cn } from '@/lib/utils';

const ProgressInstall = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      'relative h-3 w-full overflow-hidden rounded-full bg-ds-neutral-strong-default',
      className
    )}
    {...props}
  >
    {/* Shimmer background layer */}
    <div className="progress-install-shimmer" />

    <ProgressPrimitive.Indicator
      className={cn(
        'relative z-10 h-full w-full flex-1 rounded-full transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)]'
      )}
      style={{
        transform: `translateX(-${100 - (value || 0)}%)`,
        background:
          'linear-gradient(90deg, var(--colors-blue-300) 0%, var(--colors-emerald-300) 17.79%, var(--colors-fuchsia-300) 36.06%, var(--colors-orange-300) 53.37%, var(--colors-red-300) 68.27%, var(--colors-yellow-300) 80.29%, var(--colors-amber-300) 89.42%, var(--colors-indigo-300) 98.44%)',
      }}
    />
  </ProgressPrimitive.Root>
));
ProgressInstall.displayName = ProgressPrimitive.Root.displayName;

export { ProgressInstall };
